import { combineReducers } from 'redux';
import detailReducer from './detail/redux';
import deviceAdvancedSearchReducer from './advanced-search/redux';

export default combineReducers({
  detail: detailReducer,
  advancedSearch: deviceAdvancedSearchReducer
});
